import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Modal, Select, InputNumber } from 'hljd'
import Upload from '../../Upload'
import { observer } from 'mobx-react'
import style from '@components/JiaMeng/NewCustomer/style/modal.css'
import formStyle from './style.module.less'
// import MerchantSelect from './MerchantSelect'
// import RelatedOrderSelect from './RelatedOrderSelect'
import { PROPERTY_EXPERIENCE_LIST } from '@components/JiaMeng/NewCustomer/constant'
import { SelectInput } from 'hlj-components'
import { Flex } from 'hljd'
import http from '@core/fetch'
import { getMoney } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import cls from 'classnames'

const FormItem = Form.Item
const Option = Select.Option

@Form.create()
@observer
class InsertContractModal extends Component {
  state = {
    releatedOrderList: []
  }

  handleOk = e => {
    const { store, form } = this.props
    e.preventDefault()
    form.validateFields((err, values) => {
      if (!err) {
        store.createCooperateOrder({
          ...values,
          attachments: JSON.stringify(values.attachments)
        })
      }
    })
  }

  onPropertyChange = property_id => {
    this.props.store.getOrderMerchantList(property_id)
    this.props.form.setFieldsValue({
      merchant_id: ''
    })
  }

  onMerchantChange = merchant_id => {
    this.getRelatedUserOrderList(merchant_id)
    this.props.form.setFieldsValue({
      parent_order_no: ''
    })
  }

  getRelatedUserOrderList = async merchant_id => {
    if (!merchant_id) {
      this.setState({ releatedOrderList: [] })
      return
    }

    const { detailData } = this.props.store
    const { user_id, user_phone } = detailData
    const { success, data } = await http(
      '/p/wedding/Admin/APICrmBrokerage/relatedUserOrder',
      {
        body: {
          user_id,
          user_phone,
          merchant_id
        },
        expect: []
      }
    )
    if (success) {
      this.setState({ releatedOrderList: data })
    }
  }

  render() {
    const {
      form: { getFieldDecorator },
      store
    } = this.props
    const {
      insertCoopOrderModalVisible,
      detailData,
      customerName,
      orderMerchantList,
      setStoreData
    } = store
    const { user_phone } = detailData

    return (
      <Modal
        title="录入合作订单"
        visible={insertCoopOrderModalVisible}
        onOk={this.handleOk}
        onCancel={() =>
          setStoreData([{ type: 'insertCoopOrderModalVisible', value: false }])
        }
        destroyOnClose={true}
        width={480}
        wrapClassName={style.modal}
      >
        <Form className={cls(style.form, formStyle.form)}>
          <FormItem label="姓名">{customerName || '无'}</FormItem>
          <FormItem label="手机号">{user_phone || '无'}</FormItem>

          <Form.Item label="需求类型">
            {getFieldDecorator('property_id', {
              rules: [{ required: true, message: '请选择需求类型' }]
            })(
              <Select placeholder="请选择" onChange={this.onPropertyChange}>
                {PROPERTY_EXPERIENCE_LIST.map(({ id, name }) => {
                  return (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  )
                })}
              </Select>
            )}
          </Form.Item>

          <Form.Item label="商家名">
            {getFieldDecorator('merchant_id', {
              rules: [{ required: true, message: '请选择商家' }]
            })(
              <Select
                placeholder="请选择"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={this.onMerchantChange}
              >
                <Option value="">请选择</Option>
                {orderMerchantList.map(({ id, name }) => {
                  return (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  )
                })}
              </Select>
            )}
          </Form.Item>

          <Form.Item label="订单金额">
            {getFieldDecorator('total_money', {
              rules: [
                {
                  required: true,
                  message: '请输入订单金额'
                }
              ]
            })(<InputNumber placeholder="请输入" />)}
          </Form.Item>

          <Form.Item label="订单信息">
            {getFieldDecorator('order_text', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: '请输入订单信息'
                },
                {
                  max: 120,
                  message: '不超过120字'
                }
              ]
            })(<Input.TextArea placeholder="请输入" />)}
          </Form.Item>

          <div>
            {getFieldDecorator('attachments', {
              initialValue: []
            })(<Upload />)}
          </div>

          <div style={{ margin: '10px 0 7px' }}>关联用户订单（选填）:</div>
          {getFieldDecorator('parent_order_no', {
            initialValue: ''
          })(
            <SelectInput autoComplete="off" style={{ width: '100%' }}>
              {this.state.releatedOrderList.map(item => {
                const { id, parentOrderNo, actualPrice, paidMoney } = item
                return (
                  <SelectInput.Option key={id} value={parentOrderNo}>
                    <Flex>
                      <span
                        className="text-cut"
                        style={{
                          maxWidth: 200
                        }}
                      >
                        {dGet(item, 'setMeal.title')}
                      </span>

                      <span>
                        （{getMoney(actualPrice)}，已支付{getMoney(paidMoney)}）
                      </span>
                    </Flex>
                  </SelectInput.Option>
                )
              })}
            </SelectInput>
          )}
        </Form>
      </Modal>
    )
  }
}

export default InsertContractModal
